import { render, staticRenderFns } from "./publicationListPage.vue?vue&type=template&id=9fbbdcb8&"
import script from "./publicationListPage.vue?vue&type=script&lang=js&"
export * from "./publicationListPage.vue?vue&type=script&lang=js&"
import style0 from "./publicationListPage.vue?vue&type=style&index=0&id=9fbbdcb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports